import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {
    FormLabelComponent
} from "../../../common/forms/form-label/form-label.component";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    ReactiveFormsModule,
    Validators
} from "@angular/forms";
import {FormsService, SubtitlesService} from "../../../core";
import {
    FormTextInputComponent
} from "../../../common/forms/form-text-input/form-text-input.component";
import {
    FormActionButtonsComponent
} from "../../../common/forms/form-action-buttons/form-action-btns.component";
import {
    FormButtonComponent
} from "../../../common/forms/form-button/form-button.component";

@Component({
  selector: 'additional-info-form',
  standalone: true,
    imports: [
        FormLabelComponent,
        ReactiveFormsModule,
        FormTextInputComponent,
        FormActionButtonsComponent,
        FormButtonComponent
    ],
  templateUrl: './additional-info-form.component.html',
  styleUrl: './additional-info-form.component.scss'
})
export class AdditionalInfoFormComponent  implements OnInit {
    @Output() close = new EventEmitter();
    additionalInformationForm: FormGroup;

    constructor(
        private fb: FormBuilder,
        private forms: FormsService,
        private subtitles: SubtitlesService,
    ) {
    }

    ngOnInit(): void {
        this.additionalInformationForm = this.fb.group({
            city: ['', [Validators.required, Validators.maxLength(45)]],
            street: ['',[Validators.required, Validators.maxLength(45)]],
            houseNumber: ['',[Validators.required, Validators.maxLength(16)]],
            phone: ['',[Validators.required, Validators.maxLength(45)]],
            installerInformation: ['', [Validators.maxLength(255)]],
        });
        this.additionalInformationForm.patchValue({
            city: this.forms.contactForm.city,
            street: this.forms.contactForm.street,
            houseNumber: this.forms.contactForm.houseNumber,
            phone: this.forms.contactForm.phone,
            installerInformation: this.forms.contactForm.installerInformation,
        })
    }

    get cityControl() {
        return this.additionalInformationForm.get('city') as FormControl;
    }

    get streetControl() {
        return this.additionalInformationForm.get('street') as FormControl;
    }

    get houseNumberControl() {
        return this.additionalInformationForm.get('houseNumber') as FormControl;
    }

    get phoneControl() {
        return this.additionalInformationForm.get('phone') as FormControl;
    }

    get installerInformationControl() {
        return this.additionalInformationForm.get('installerInformation') as FormControl;
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    closeForm(): void {
        this.close.emit();
    }

    sendContactData() {
        this.forms.contactForm.city = this.cityControl.value;
        this.forms.contactForm.street = this.streetControl.value;
        this.forms.contactForm.houseNumber = this.houseNumberControl.value;
        this.forms.contactForm.phone = this.phoneControl.value;
        this.forms.contactForm.installerInformation = this.installerInformationControl.value;
        this.forms.changeContactData(this.forms.hasContactData ? '' : 'add');
        this.closeForm();
    }
}
